/**
 * @generated SignedSource<<602805adc273240e398d3165e40050a2>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseModalContainer_photo$data = {
  readonly name: string | null;
  readonly path: string | null;
  readonly room: {
    readonly name: string | null;
    readonly urlLabel: string | null;
    readonly value: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly styles: ReadonlyArray<{
    readonly name: string | null;
    readonly urlLabel: string | null;
    readonly value: string | null;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFirmDetailsRenderer_searchBrowsePhoto" | "interiorsPhotosTracking_searchBrowsePhoto">;
  readonly " $fragmentType": "PhotosSearchBrowseModalContainer_photo";
};
export type PhotosSearchBrowseModalContainer_photo$key = {
  readonly " $data"?: PhotosSearchBrowseModalContainer_photo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseModalContainer_photo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseModalContainer_photo",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PhotosSearchBrowseFirmDetailsRenderer_searchBrowsePhoto"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "interiorsPhotosTracking_searchBrowsePhoto",
      "selections": [
        (v0/*:: as any*/)
      ],
      "args": null,
      "argumentDefinitions": []
    },
    (v1/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    },
    (v0/*:: as any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhotoStyle",
      "kind": "LinkedField",
      "name": "styles",
      "plural": true,
      "selections": [
        (v1/*:: as any*/),
        (v2/*:: as any*/),
        (v3/*:: as any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TradePhotoStyle",
      "kind": "LinkedField",
      "name": "room",
      "plural": false,
      "selections": [
        (v2/*:: as any*/),
        (v1/*:: as any*/),
        (v3/*:: as any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowsePhoto",
  "abstractKey": null
};
})();

(node as any).hash = "99e66b835547574a3d7d0103660172fb";

export default node;
